export default "/images/1863c032e8c686ae8d87c67b656681f5.avif";